const CARTO_API_KEY = (process.env.REACT_APP_CARTO_API_KEY || '').trim();

/**
 * Monta URLs de tiles da Carto com a chave configurada no build do frontend.
 * A chave fica visível no navegador, portanto deve ter restrição por domínio.
 */
export function cartoTileUrl(stylePath) {
  const baseUrl =
    `https://basemaps.cartocdn.com/${stylePath}/{z}/{x}/{y}{r}.png`;

  return CARTO_API_KEY
    ? `${baseUrl}?key=${encodeURIComponent(CARTO_API_KEY)}`
    : baseUrl;
}
